/**
 * @file OrderPriorityBadge.tsx
 * @description Priority indicator badge (Normal, Rush, VIP) with one-tap toggle for kitchen staff.
 */

import React from 'react';
import { Flame, Star } from 'lucide-react';
import type { KitchenPriority } from '../../../types/order.types';

interface OrderPriorityBadgeProps {
  priority: KitchenPriority;
  onTogglePriority: () => void;
}

export const OrderPriorityBadge: React.FC<OrderPriorityBadgeProps> = ({ priority, onTogglePriority }) => {
  if (priority === 'rush') {
    return (
      <button
        type="button"
        onClick={onTogglePriority}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 min-h-[34px] rounded-lg text-xs font-black tracking-wider uppercase bg-rose-600 text-white shadow-lg shadow-rose-900/40 hover:bg-rose-500 active:scale-95 transition-all cursor-pointer"
      >
        <Flame className="w-3.5 h-3.5 fill-white animate-pulse" />
        <span>RUSH</span>
      </button>
    );
  }

  if (priority === 'vip') {
    return (
      <button
        type="button"
        onClick={onTogglePriority}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 min-h-[34px] rounded-lg text-xs font-bold uppercase bg-amber-500/20 text-amber-300 border border-amber-500/40 hover:bg-amber-500/30 active:scale-95 transition-all cursor-pointer"
      >
        <Star className="w-3.5 h-3.5 fill-amber-300" />
        <span>VIP</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onTogglePriority}
      className="inline-flex items-center gap-1 px-3 py-1.5 min-h-[34px] rounded-lg text-xs font-semibold text-zinc-400 bg-zinc-900 border border-zinc-800 hover:text-rose-400 hover:border-rose-900/50 active:scale-95 transition-all cursor-pointer"
      title="Click to mark as Rush"
    >
      <span>Set Rush</span>
    </button>
  );
};
